<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header">
          {{ t.bet_ticket_query }}
        </div>
        <div class="card-header">
          <div class="row">
            <DateFilter :startDate="startDate" :endDate="endDate"></DateFilter>
            <div style="clear:both" class="mobilsisbr"></div>
            <div class="col-sm-3">
              <label>{{  t.betting.title.status }}</label>
              <select class="form-control" v-model="status" id="durum" name="durum">
                <option value="0" selected="selected">{{ t.all }}</option>
                <option :value="r.id" v-for="r in result">{{ r.name }}</option>
              </select>
            </div>
            <div class="col-sm-3">
              <label>{{ t.live }}</label>
              <select class="form-control" v-model="isLive" id="canli" name="canli">
                <option value="0" selected="selected">{{ t.all }}</option>
                <option value="1">{{ t.alert.button.yes }}</option>
              </select>
            </div>
            <div class="col-sm-3">
              <label>Card NO</label>
              <CustomerSearch usageArea="client" list="1"></CustomerSearch>
            </div>
            <div style="clear:both" class="mobilsisbr"></div>
            <div class="col-sm-2">
              <input type="submit" @click="fetchCoupons()" class="btn btn-success btn-block" :value="t.query_now" style="margin-top:2px">
            </div>
          </div>
        </div>
        <div class="card-block p-0"></div>
      </div>
      <div class="card">
        <div class="card-block p-0">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th width="25%">{{ t.betting.title.date }}</th>
                <th width="25%">{{ t.coupon }}</th> <!-- tr -->
                <th width="25%">{{ t.betting.title.bet_type }}</th> <!-- tr -->
                <th width="25%">{{ t.amount }}</th> <!-- tr -->
                <th width="25%">{{ t.betting.title.earnings }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="bets.length < 1">
                  <td colspan="4" align="center">{{ t.error.notfound_content_list}}</td> <!-- tr -->
                </tr>
                <tr v-for="(bet, idx) in bets" :key="idx">
                  <td>{{ dateTimeFormat(bet.coupon.created_at) }}</td>
                  <td>
                    <router-link :to="{name: 'CouponDetail', params: {coupon_id: bet.coupon.id}}" tag="a" class="btn btn-primary btn-xs">
                      {{ bet.coupon.id }}
                    </router-link>
                  </td>
                  <td :class="bet.coupon.result.key">{{ bet.result }}</td>
                  <td>{{ bet.coupon.amount | toMoney(session.currency) }}</td>
                  <td v-if="calculated_earnings > 0">{{ bet.coupon.calculated_earnings | toMoney(session.currency) }}</td>
                  <td v-else>{{ bet.coupon.earnings | toMoney(session.currency) }}</td>
                </tr>
              </template>
              </tbody>
            </table>
            <div class="fixed-table-footer">
              <paginate v-if="pagination" class="mx-3"
                        :page-count="pagination.pageCount"
                        :page-range="pagination.pageRange"
                        :force-page="pagination.current"
                        :initialPage="pagination.current"
                        :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                        :click-handler="onChangePage"
                        :prev-text="t.previous"
                        :next-text="t.next"
                        :container-class="'my-1 pagination float-right mr-0 ml-1'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import CustomerSearch from "../CustomerSearch";
import Paginate from 'vuejs-paginate'
import Loading from "../Loading";
export default {
  name: "CardBayi",
  components: {Loading, CustomerSearch, Paginate, DateFilter},
  data() {
    return {
      session: session,
      bets: [],
      result: [],
      status: 0,
      isLive: 0,
      uid: '',
      pagination: null,
      t: this.$root.t,
      loading: false,
      startDate: moment(new Date(new Date().setDate(new Date().getDate() - 2))).format("DD MMMM YYYY ddd"),
      endDate: moment(new Date()).format("DD MMMM YYYY ddd"),
    }
  },
  mounted() {
    this.fetchBetResults();

    if(this.$route.query.uid) {
      this.uid = this.$route.query.uid;
    }
  },
  watch: {
    uid() {
      this.pagination = null;
      this.fetchCoupons()
      this.fetchBetResults()
    }
  },
  methods: {
    async fetchCoupons() {
      this.loading = true
      this.$http.get(api + 'api/v1/bets', {
        params: {
          page: this.$route.query.page,
          per_page: 10,
          uid: this.uid,
          wb: 1,
          locale: this.session.locale.locale,
          isLive: this.isLive,
          status: (this.status > 0) ? [this.status] : null,
          createdAt: {from: this.startDate, to: this.endDate}
        }
      }).then(response => {

        if(response.body.result){
          this.bets = response.body.result.bets;
          this.pagination = response.body.pagination;
          this.loading = false
        }else {

          this.loading = false
        }
        }, response => {
          this.loading = false
        })
    },
    async fetchBetResults() {
      this.$http.get(bsapi + 'api/v1/bet/results?locale='+this.session.locale.locale).then(response => {
          this.result = response.body;
      })
    },
    onChangePage (page) {
      this.pagination.current = page;
      this.$router.push({ query: {page: page} });
      window.scroll(0, 0);
      this.fetchCoupons()
    },
  }
}
</script>

<style scoped>
.win {
  color: green;
}

.loss {
  color: red;
}

.cancelled {
  color: blue;
}

</style>



// WEBPACK FOOTER //
// src/components/views/CardBayi.vue